export enum UmpireOttEventKind {
  LIVE = 'live',
  VOD = 'vod',
}
